import { render } from "./ResourcesPage.vue?vue&type=template&id=f2e794ce&scoped=true"
import script from "./ResourcesPage.vue?vue&type=script&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&lang=js"

import "./ResourcesPage.vue?vue&type=style&index=0&id=f2e794ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e794ce"]])

export default __exports__